var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showSelect)?_c('el-select',{on:{"change":_vm.handleValueChange},model:{value:(_vm.orgId),callback:function ($$v) {_vm.orgId=$$v},expression:"orgId"}},_vm._l((_vm.organizationUnits),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.value,"value":item.key}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }